export const defaultLocale = "zh";

export const locales = [
  { code: "zh", label: "中文" },
  { code: "en", label: "EN" },
];

export const dictionary = {
  zh: {
    brand: "爱尔兰生活导航站",
    brandHint: "爱尔兰生活导航站",
    navHome: "首页",
    navProjects: "推荐项目",
    navCategories: "全部分类",
    navAbout: "更新列表",
    heroEyebrow: "爱尔兰本地生活入口大厅",
    heroTitle: "爱尔兰生活服务入口，一站直达安全、租房、保险与安家指南",
    heroDescription:
      "把安全地图、保险比价、租房、PPSN、税务、医疗、交通等入口做成高密度导航。适合 Cloudflare Workers 按 /safe、/insurance 等路径聚合多个独立子项目。",
    primaryCta: "进入推荐区",
    secondaryCta: "查看全部分类",
    searchPlaceholder: "输入关键词：安全、保险、租房、PPSN、税务、GP、公交",
    searchLabel: "搜服务",
    hotSearchLabel: "热门搜索",
    clearLabel: "清空",
    featuredTitle: "今日推荐",
    featuredSubtitle: "重点项目放在最显眼的位置，像小游戏推荐位一样快速进入。",
    categoriesTitle: "服务大厅",
    categoriesSubtitle: "按模块聚合入口，卡片数量可以持续扩展，配置里加一条即可自动出现。",
    emptyTitle: "没有找到匹配入口",
    emptyDescription: "试试 safe、insurance、rent、tax、GP、签证 或 公交。",
    openLabel: "开始使用",
    linksLabel: "快捷入口",
    themeLight: "亮色",
    themeDark: "暗色",
    languageLabel: "语言",
    statsProjects: "推荐项目",
    statsCategories: "分类专区",
    statsLinks: "快捷入口",
    rankingTitle: "热门榜",
    newTitle: "新手必点",
    footerText: "爱尔兰本地生活服务入口站，支持按路径聚合无限扩展。",
  },
  en: {
    brand: "Ireland Life Arcade",
    brandHint: "Ireland Life Arcade",
    navHome: "Home",
    navProjects: "Featured",
    navCategories: "All Categories",
    navAbout: "Updates",
    heroEyebrow: "A local living arcade for Ireland",
    heroTitle: "Your Ireland life service portal for safety, renting, insurance and settling in",
    heroDescription:
      "A high-density portal for safety maps, insurance comparison, renting, PPSN, tax, healthcare, transport and more. Built for Cloudflare Workers path aggregation across /safe, /insurance and future sub-projects.",
    primaryCta: "Enter featured",
    secondaryCta: "Browse all",
    searchPlaceholder: "Search safety, insurance, rent, PPSN, tax, GP or transport",
    searchLabel: "Search services",
    hotSearchLabel: "Hot searches",
    clearLabel: "Clear",
    featuredTitle: "Today Picks",
    featuredSubtitle: "Important projects get arcade-style entry cards for fast access.",
    categoriesTitle: "Service Arcade",
    categoriesSubtitle:
      "Grouped service entrances can grow indefinitely. Add one config item and the homepage renders it.",
    emptyTitle: "No matching entrance",
    emptyDescription: "Try safe, insurance, rent, tax, GP, visa or transport.",
    openLabel: "Start",
    linksLabel: "Quick links",
    themeLight: "Light",
    themeDark: "Dark",
    languageLabel: "Language",
    statsProjects: "Featured",
    statsCategories: "Zones",
    statsLinks: "Entrances",
    rankingTitle: "Hot List",
    newTitle: "Starter Picks",
    footerText: "A path-friendly Ireland local-life portal designed for unlimited expansion.",
  },
};

export const hotKeywords = [
  { zh: "安全地图", en: "Safety map", query: "safe" },
  { zh: "保险", en: "Insurance", query: "insurance" },
  { zh: "租房", en: "Rent", query: "rent" },
  { zh: "PPSN", en: "PPSN", query: "ppsn" },
  { zh: "税务", en: "Tax", query: "tax" },
  { zh: "GP", en: "GP", query: "gp" },
];

export const heroProjects = [
  {
    id: "safe",
    href: "/safe",
    accent: "green",
    thumbnail: "safety",
    rank: "01",
    status: { zh: "强烈推荐", en: "Top Pick" },
    title: { zh: "安全区域地图", en: "Safety Area Map" },
    description: {
      zh: "查看都柏林及爱尔兰区域安全指数、犯罪信号、地图图层和社区反馈。",
      en: "Explore area safety scores, crime signals, map layers and community feedback across Ireland.",
    },
    tags: {
      zh: ["安全指数", "地图", "社区反馈"],
      en: ["Safety score", "Map", "Feedback"],
    },
    keywords: ["safe", "crime", "map", "safety", "安全", "地图"],
  },
  {
    id: "insurance",
    href: "/insurance",
    accent: "blue",
    thumbnail: "insurance",
    rank: "02",
    status: { zh: "高频入口", en: "Popular" },
    title: { zh: "保险比价助手", en: "Insurance Compare" },
    description: {
      zh: "聚合车险、租房险、健康险、旅行险入口，快速找到适合自己的方案。",
      en: "Compare entrances for car, renter, health and travel insurance options.",
    },
    tags: {
      zh: ["车险", "租房险", "健康保险"],
      en: ["Car", "Renters", "Health"],
    },
    keywords: ["insurance", "car", "health", "保险", "车险"],
  },
  {
    id: "settle",
    href: "/settle",
    accent: "orange",
    thumbnail: "settle",
    rank: "03",
    status: { zh: "新手必点", en: "Starter" },
    title: { zh: "落地安家清单", en: "Settling Checklist" },
    description: {
      zh: "PPSN、银行卡、GP、手机卡、公共交通等新移民和留学生高频事项导航。",
      en: "PPSN, banking, GP registration, mobile plans, transport and first-week essentials.",
    },
    tags: {
      zh: ["PPSN", "银行卡", "GP"],
      en: ["PPSN", "Banking", "GP"],
    },
    keywords: ["settle", "ppsn", "bank", "gp", "安家", "新手"],
  },
  {
    id: "rent",
    href: "/rent",
    accent: "rose",
    thumbnail: "rent",
    rank: "04",
    status: { zh: "租房专区", en: "Housing" },
    title: { zh: "租房入口大全", en: "Rental Starter" },
    description: {
      zh: "租房平台、合同检查、押金提醒、区域选择和搬家服务一站聚合。",
      en: "Rental platforms, lease checks, deposit reminders, area selection and moving support.",
    },
    tags: {
      zh: ["租房", "合同", "押金"],
      en: ["Rent", "Lease", "Deposit"],
    },
    keywords: ["rent", "lease", "deposit", "daft", "租房"],
  },
];

export const categories = [
  {
    id: "daily",
    color: "cyan",
    thumbnail: "daily",
    title: { zh: "生活服务", en: "Daily Services" },
    description: {
      zh: "交通、医疗、通信、公共服务。",
      en: "Transport, healthcare, telecoms and public services.",
    },
    items: [
      { title: { zh: "公共交通", en: "Public Transport" }, href: "/transport", keywords: ["bus", "luas", "dart", "交通"], badge: "HOT" },
      { title: { zh: "GP 医疗注册", en: "GP Healthcare" }, href: "/healthcare", keywords: ["gp", "doctor", "medical", "医疗"], badge: "NEW" },
      { title: { zh: "手机宽带", en: "Mobile Broadband" }, href: "/utilities/mobile", keywords: ["sim", "broadband", "phone", "手机"] },
      { title: { zh: "水电气账单", en: "Utilities" }, href: "/utilities", keywords: ["electricity", "gas", "bill", "电费"] },
      { title: { zh: "紧急电话", en: "Emergency Numbers" }, href: "/emergency", keywords: ["emergency", "112", "999", "紧急"] },
      { title: { zh: "超市比价", en: "Groceries" }, href: "/groceries", keywords: ["tesco", "aldi", "lidl", "超市"] },
    ],
  },
  {
    id: "finance",
    color: "amber",
    thumbnail: "finance",
    title: { zh: "财税法律", en: "Finance & Legal" },
    description: {
      zh: "税务、银行、会计、律师。",
      en: "Tax, banking, accounting and solicitors.",
    },
    items: [
      { title: { zh: "PPSN 申请", en: "PPSN Application" }, href: "/ppsn", keywords: ["ppsn", "welfare", "身份"], badge: "HOT" },
      { title: { zh: "个人税务", en: "Personal Tax" }, href: "/tax", keywords: ["revenue", "tax", "税"], badge: "HOT" },
      { title: { zh: "银行开户", en: "Bank Accounts" }, href: "/banking", keywords: ["bank", "revolut", "银行"] },
      { title: { zh: "律师服务", en: "Solicitors" }, href: "/legal", keywords: ["solicitor", "law", "律师"] },
      { title: { zh: "会计报税", en: "Accountants" }, href: "/accounting", keywords: ["accountant", "self employed", "会计"] },
      { title: { zh: "福利补助", en: "Benefits" }, href: "/benefits", keywords: ["welfare", "benefits", "补助"] },
    ],
  },
  {
    id: "housing",
    color: "pink",
    thumbnail: "housing",
    title: { zh: "房屋租赁", en: "Housing & Renting" },
    description: {
      zh: "租房、区域、合同、搬家。",
      en: "Renting, areas, leases and moving.",
    },
    items: [
      { title: { zh: "租房入口", en: "Rental Search" }, href: "/rent", keywords: ["rent", "daft", "租房"], badge: "HOT" },
      { title: { zh: "区域安全", en: "Area Safety" }, href: "/safe", keywords: ["safe", "crime", "安全"], badge: "TOP" },
      { title: { zh: "租房合同", en: "Lease Check" }, href: "/rent/lease", keywords: ["lease", "deposit", "合同"] },
      { title: { zh: "搬家仓储", en: "Moving Storage" }, href: "/moving", keywords: ["moving", "storage", "搬家"] },
      { title: { zh: "押金提醒", en: "Deposit Guide" }, href: "/rent/deposit", keywords: ["deposit", "rtdb", "押金"] },
      { title: { zh: "区域选择", en: "Area Picker" }, href: "/areas", keywords: ["neighbourhood", "area", "区域"] },
    ],
  },
  {
    id: "work-study",
    color: "violet",
    thumbnail: "work",
    title: { zh: "工作留学", en: "Work & Study" },
    description: {
      zh: "求职、签证、学校、培训。",
      en: "Jobs, visas, schools and training.",
    },
    items: [
      { title: { zh: "求职资源", en: "Job Resources" }, href: "/jobs", keywords: ["jobs", "career", "求职"] },
      { title: { zh: "签证移民", en: "Visa Immigration" }, href: "/immigration", keywords: ["visa", "irish residence permit", "签证"], badge: "HOT" },
      { title: { zh: "学校课程", en: "Schools Courses" }, href: "/education", keywords: ["school", "course", "留学"] },
      { title: { zh: "技能培训", en: "Training" }, href: "/training", keywords: ["training", "skill", "培训"] },
      { title: { zh: "实习入口", en: "Internships" }, href: "/internships", keywords: ["internship", "graduate", "实习"] },
      { title: { zh: "简历面试", en: "CV Interview" }, href: "/career/cv", keywords: ["cv", "interview", "简历"] },
    ],
  },
  {
    id: "travel",
    color: "green",
    thumbnail: "travel",
    title: { zh: "出行旅行", en: "Travel" },
    description: {
      zh: "机场、驾照、旅游、住宿。",
      en: "Airport, driving, trips and stays.",
    },
    items: [
      { title: { zh: "机场交通", en: "Airport Transfer" }, href: "/airport", keywords: ["airport", "dublin", "机场"] },
      { title: { zh: "驾照换证", en: "Driving Licence" }, href: "/driving", keywords: ["driving", "licence", "驾照"] },
      { title: { zh: "周末旅行", en: "Weekend Trips" }, href: "/travel/weekend", keywords: ["travel", "trip", "旅行"] },
      { title: { zh: "酒店住宿", en: "Hotels" }, href: "/travel/hotels", keywords: ["hotel", "stay", "住宿"] },
    ],
  },
  {
    id: "tools",
    color: "blue",
    thumbnail: "tools",
    title: { zh: "实用工具", en: "Tools" },
    description: {
      zh: "计算器、清单、模板、提醒。",
      en: "Calculators, checklists, templates and reminders.",
    },
    items: [
      { title: { zh: "到手工资", en: "Net Salary" }, href: "/tools/salary", keywords: ["salary", "tax", "工资"], badge: "NEW" },
      { title: { zh: "租房预算", en: "Rent Budget" }, href: "/tools/rent-budget", keywords: ["rent", "budget", "预算"] },
      { title: { zh: "保险清单", en: "Insurance Checklist" }, href: "/tools/insurance-checklist", keywords: ["insurance", "checklist", "保险"] },
      { title: { zh: "搬家清单", en: "Moving Checklist" }, href: "/tools/moving-checklist", keywords: ["moving", "checklist", "搬家"] },
    ],
  },
];
